"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./QABenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/engagement.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "Customer Satisfaction",
      description: "Improve your business reputation by providing high-quality products to your customers.",
    },
    {
      iconSrc: "/calci.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "INCREASE CUSTOMER LOYALTY",
      title: "Cost Savings",
      description: "Identifying and correcting problems early in the development process lowers the overall development cost.",
    },
    {
      iconSrc: "/scale.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "Seamless usability",
      description: "With meticulous attention to detail, we guarantee a flawless and error-free product, setting the standard for excellence in usability.",
    },
    {
      iconSrc: "/build.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "Better Collaboration",
      description:
        "Involving everyone in the QA process develops a collaborative and shared responsibility culture, which can lead to better software outcomes.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title4130 animate-left" ref={headerRef}>
           THE BENEFITS OF
             
            
            
            <span className="scoping-benefits-highlight"> QUALITY ASSURANCE</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
           Quality assurance makes sure the software is reliable, performs well, and satisfies users. It builds confidence by encouraging improvement and efficiency, reducing risks during software launch.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
